// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__k0zp3"};